module.exports = __webpack_public_path__ + "static/img/title_web_huozhu.b5fcecee.png";